import { gql } from '@apollo/client';

export const QUERY = gql`
  query ListInstallmentPlans($scopeId: Int!, $scopeType: String!) {
    listInstallmentPlans(scopeId: $scopeId, scopeType: $scopeType) {
      id
      scopeType
      scopeId
      name
      enabled
      depositType
      depositAmount
      installmentCount
      frequencyType
      frequencyAmount
      withdrawDay
      withdrawBasedOnCheckout
    }
  }
`;
